import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { SpookyLayer } from "@/components/SpookyLayer";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Tokenomics } from "@/components/Tokenomics";
import { HowToBuy } from "@/components/HowToBuy";
import { Community } from "@/components/Community";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain relative bg-[#080808] min-h-screen" data-testid="hallowin-app">
      <SpookyLayer />
      <Nav />
      <main className="relative">
        <Hero />
        <Marquee />
        <About />
        <Tokenomics />
        <HowToBuy />
        <Community />
        <FinalCTA />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
